angular.module('aprima-utils').filter('apPhoneNumberFilter',
    ['_',
        function (_) {
            'use strict';

            return function (number){
                number = _.trim(number, '()- ');
                number=number.substring(0,number.length-10)+
                    '('+number.substring(number.length-10,number.length-7)+
                    ')'+number.substring(number.length-7,number.length-4)+
                    '-'+number.substring(number.length-4,number.length);
                return number;
            };
}]);
